export enum IcpIntelAggregationStatusEnum {
  CREATED = 'CREATED',
  COLLECTION = 'COLLECTION',
  COLLECTION_COMPLETED = 'COLLECTION_COMPLETED',
  COLLECTION_ERROR = 'COLLECTION_ERROR',
  AGGREGATION = 'AGGREGATION',
  AGGREGATION_COMPLETED = 'AGGREGATION_COMPLETED',
  AGGREGATION_ERROR = 'AGGREGATION_ERROR'
}

const ERROR_STATUS_LIST: IcpIntelAggregationStatusEnum[] = [
  IcpIntelAggregationStatusEnum.AGGREGATION_ERROR,
  IcpIntelAggregationStatusEnum.COLLECTION_ERROR,
];

const COMPLETED_STATUS_LIST: IcpIntelAggregationStatusEnum[] = [
  ...ERROR_STATUS_LIST,
  IcpIntelAggregationStatusEnum.AGGREGATION_COMPLETED,
];

export namespace IcpIntelAggregationStatusEnum {
  export function getErrorStatusList(): IcpIntelAggregationStatusEnum[] {
    return ERROR_STATUS_LIST;
  }
  export function getCompletedStatusList(): IcpIntelAggregationStatusEnum[] {
    return COMPLETED_STATUS_LIST;
  }
}
